import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {UserLight} from '../models/userLight';
import * as _ from 'lodash';
import {ToastrService} from 'ngx-toastr';
import {ActivatedRoute, ParamMap, Router} from '@angular/router';
import {PhonePipe} from '../../pipes/phone.pipe';
import {ClientService} from '../../clients-module/services/client.service';
import {Subject, Subscription} from 'rxjs';
import {ClientLocation, UserInvitationProperties} from '../../clients-module/models/clientLocation';
import {UserService} from '../services/user.service';
import {ObjectUpdatePayload} from '../../models/screeningInvite';
import {PropertyService} from 'src/app/property-module/services/property.service';
import { MatLegacySlideToggleChange as MatSlideToggleChange } from '@angular/material/legacy-slide-toggle';
import * as moment from 'moment';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-users-view',
  templateUrl: './users-view.component.html',
  styleUrls: ['./users-view.component.less']
})
export class UsersViewComponent implements OnInit, AfterViewInit, OnDestroy {
  userChanges: UserLight = new UserLight();
  userCurrentPass: string;
  userNewPass: string;
  userVerifyPass: string;
  userToEdit: UserLight;
  userToEditID: number;
  selfEdit = false;
  clientId: number;
  clientUsers: Array<UserLight>;
  clientlistner$: Subject<any>;
  sub: Subscription;
  locationToAssign: ClientLocation;
  locationToRemove: ClientLocation;
  userLocations: Array<ClientLocation>;
  updates: ObjectUpdatePayload[] = [];
  propertyUpdates: UserInvitationProperties[] = [];
  removingLocation = false;
  clientsLoaded$: Subject<any>;
  loadedsub: Subscription;

  addLocationSub$: Subscription;
  removeLocationSub$: Subscription;
  updatePassSub$: Subscription;
  fetchUserLocSub$: Subscription;

  constructor(public auth: AuthService,
              public toast: ToastrService,
              public router: Router,
              public activatedRoute: ActivatedRoute,
              public phonePipe: PhonePipe,
              public clients: ClientService,
              public props: PropertyService,
              public usr: UserService) {
  }

  ngOnDestroy(): void {
    if(this.addLocationSub$) this.addLocationSub$.unsubscribe();
    if(this.removeLocationSub$) this.removeLocationSub$.unsubscribe();
    if(this.updatePassSub$) this.updatePassSub$.unsubscribe();
    if(this.fetchUserLocSub$) this.fetchUserLocSub$.unsubscribe();
  }

  ngAfterViewInit(): void {
  }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe((p: ParamMap) => {
      this.userToEditID = parseInt(p.get('user'));

      if (!this.auth.loggedInUser) {
        this.auth.userFetchComplete.subscribe((r: boolean) => {
          if (!this.clientId) {
            this.clientId = this.auth.loggedInUser.clientId;
          }
        });
      } else {
        if (!this.clientId) {
          this.clientId = this.auth.loggedInUser.clientId;
        }
      }

      if (!this.userToEditID) {
        this.userToEdit = this.auth.loggedInUser;
        this.selfEdit = true;
      } else {
        // Go get the user.
        this.auth.FetchUser(this.userToEditID).subscribe(
          (r: UserLight) => {
            this.userToEdit = r;
            this.fetchUserLocations();
            this.props.FetchPropertiesForClient(r.clientId);

          },
          (error) => {
          });
      }
    });
  }


  saveUserUpdates(): void {

    if (this.userNewPass && this.testPasswordStrength(this.userNewPass) && (this.userNewPass == this.userVerifyPass)) {
      // if they have entered a new password AND it matches the verify password, then we can call off to update their PW
      this.updatePassSub$ = this.auth.ChangePassword({old: this.userCurrentPass, new: this.userNewPass}).subscribe(
        (resp: any) => {
          this.toast.success('Password successfully updated!');
          this.userCurrentPass = undefined;
          this.userNewPass = undefined;
          this.userVerifyPass = undefined;
          this.sendUserUpdates();
        },
        (err: HttpErrorResponse) => {
          if(err.status == 406) {
            this.toast.error('Your password may be vulnerable. Please choose another password.');
          }
          else {
            this.toast.error('There was an error updating your password.', '', {disableTimeOut: true, closeButton: true});
          }
        });
    } else if (this.userNewPass != this.userVerifyPass) {
      this.toast.error('Passwords do not match.', '', {disableTimeOut: true, closeButton: true});
    } else {
      this.sendUserUpdates();
    }

  }

  sendUserUpdates(): void {
    // validate fields here
    let valid = true;
    const emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
    if (!emailRegex.test(this.userChanges.email) && this.userChanges.email) {
      valid = false;
      this.toast.error('Please provide a properly formatted email address.', '', {disableTimeOut: true, closeButton: true});
    }

    // let phoneRegex = new RegExp(/^\(\d{3}\) \d{3}-\d{4}$/);
    const phoneRegex = new RegExp(/^\d{10}$/);
    if (!phoneRegex.test(this.userChanges.fax) && this.userChanges.fax) {
      valid = false;
      this.toast.error('Please provide a ten digit fax number.', '', {disableTimeOut: true, closeButton: true});
    }

    if (!phoneRegex.test(this.userChanges.mobilePhone) && this.userChanges.mobilePhone) {
      valid = false;
      this.toast.error('Please provide a ten digit mobile phone number.', '', {disableTimeOut: true, closeButton: true});
    }

    if (!phoneRegex.test(this.userChanges.officePhone) && this.userChanges.officePhone) {
      valid = false;
      this.toast.error('Please provide a ten digit office phone number.', '', {disableTimeOut: true, closeButton: true});
    }

     if (valid) {

      this.usr.UpdateUser(this.userToEdit).subscribe((success: boolean) => {
          if (success) {
            this.toast.success('User updated successfully.', 'Update Succeeded!');
            this.updates = [];
          } else {
            this.toast.error('User update failed.', 'Update Failed!', {disableTimeOut: true, closeButton: true});
          }
        },
        (error) => {
          this.toast.error('User update failed.', 'Update Failed!', {disableTimeOut: true, closeButton: true});
        }
      );
    }
  }

  testPasswordStrength(password: string): boolean {
    const lowercaseCheck = new RegExp('(?=.*[a-z])');
    const upperCaseCheck = new RegExp('(?=.*[A-Z])');
    const numericCheck = new RegExp('(?=.*[0-9])');
    const specialCharacterCheck = new RegExp('(?=.[!@#\$%\^&])');
    const lengthCheck = new RegExp('(?=.{8,})');
    if (!lowercaseCheck.test(password)) {
      this.toast.error('Password does not meet minimum requirements.', '', {disableTimeOut: true, closeButton: true});
      return false;
    } else if (!upperCaseCheck.test(password)) {
      this.toast.error('Password does not meet minimum requirements.', '', {disableTimeOut: true, closeButton: true});
      return false;
    } else if (!numericCheck.test(password)) {
      this.toast.error('Password does not meet minimum requirements.', '', {disableTimeOut: true, closeButton: true});
      return false;
    } else if (!specialCharacterCheck.test(password)) {
      this.toast.error('Password does not meet minimum requirements.', '', {disableTimeOut: true, closeButton: true});
      return false;
    } else if (!lengthCheck.test(password)) {
      this.toast.error('Password does not meet minimum requirements.', '', {disableTimeOut: true, closeButton: true});
      return false;
    }
    return true;
  }


  fetchUserLocations() {
    this.usr.FetchUserLocations(this.userToEdit.id).subscribe((locs) => {
        this.userLocations = locs;
        this.userLocations.sort((a, b) => {
          if (a.locationName < b.locationName) {
            return -1;
          }
          if (a.locationName > b.locationName) {
            return 1;
          }
          return 0;
        });
      },
      (error) => {

        this.toast.error('There was an error fetching your user locations', '', {closeButton: true, disableTimeOut: true});
      });
  }

  addToAllLocations(): void {
    // determine which locations the user does NOT have access to:
    const unaddedLocs = _.differenceBy(this.props.properties, this.userLocations, 'id');
    unaddedLocs.forEach(loc => {
      const pld = new UserInvitationProperties();
      pld.userId = this.userToEdit.id;
      pld.clientLocationId = loc.id
      this.propertyUpdates.push(pld);
    });
    this.SendLocationAssignment(false);
    unaddedLocs.forEach(l => this.userLocations.push(l));
    this.userLocations.sort((a, b) => {
      if (a.locationName < b.locationName) {
        return -1;
      }
      if (a.locationName > b.locationName) {
        return 1;
      }
      return 0;
    });
  }

  assignToLocation(): void {
    // check to see if the location is already in the user's currentLocations
    const result = this.userLocations.find(loc => {
      return loc.id == this.locationToAssign.id;
    });
    if (!result) {
      const pld = new UserInvitationProperties();
      pld.userId = this.userToEdit.id;
      pld.clientLocationId = this.locationToAssign.id
      this.propertyUpdates.push(pld);
      this.SendLocationAssignment(true);
      this.userLocations.sort((a, b) => {
        if (a.locationName < b.locationName) {
          return -1;
        }
        if (a.locationName > b.locationName) {
          return 1;
        }
        return 0;
      });
    } else {
      this.toast.error('User is already assigned to this location.', '', {closeButton: true, disableTimeOut: true});
    }
  }

  showRemoveDialogue(loc: ClientLocation): void {
    this.locationToRemove = loc;
    this.removingLocation = true;

  }

  removeFromLocation(): void {
    const pld = new UserInvitationProperties();
    pld.userId = this.userToEdit.id;
    pld.clientLocationId = this.locationToRemove.id
    this.propertyUpdates.push(pld);

    // make the api call
    this.removeLocationSub$ = this.usr.RemovePropertyFromUser(this.propertyUpdates).subscribe(rslt => {

        // remove prop the stored list, then re-sort
        this.userLocations = this.userLocations.filter(loc => this.locationToRemove != loc);
        this.userLocations.sort((a, b) => {
          if (a.locationName < b.locationName) {
            return -1;
          }
          if (a.locationName > b.locationName) {
            return 1;
          }
          return 0;
        });
        this.toast.success('Property sucesfully removed from user.');
        this.removingLocation = false;

      },
      (error) => {
        this.toast.success('Failed to remove property from user.', '', {disableTimeOut: true, closeButton: true});
      },
      () => this.removeLocationSub$.unsubscribe());
  }

  SendLocationAssignment(single: boolean) {
    this.addLocationSub$ = this.usr.AddPropertyToUser(this.propertyUpdates).subscribe((rslt: boolean) => {
        if (single) {
          this.userLocations.push(this.locationToAssign);
          this.propertyUpdates = [];
          this.locationToAssign = null;
          this.toast.success('Property successfully added to user!', 'Property Add Success');
        } else {
          this.propertyUpdates = [];
          this.locationToAssign = null;
          this.toast.success('Properties successfully added to user!', 'Properties Add Success');
        }
      },
      (error) => {
        this.toast.error('Failed to add property to user!', 'Property Add Failure', {closeButton: true, disableTimeOut: true});
      },
      () => this.addLocationSub$.unsubscribe());
  }

  public sendPasswordResetLink(): void {
    this.auth.SendForgotPasswordLink(this.userToEdit.userName).subscribe((r: any) => {
        this.toast.success('Password update Link sent.', 'Link Sent!');
      },
      () => {
        this.toast.error('There was an error sending your password reset link.', '', {disableTimeOut: true, closeButton: true});

      });
  }
}
